<template>
  <form class="o-form" @submit.prevent="submit">
    <slot name="header" />
    <slot name="row" />
    <slot name="formButtons" />
  </form>
</template>

<script>
import addSlotClasses from '../mixins/slotClassAddition';
import { VButton, VInput } from '../atoms';

export default {
  name: 'v-form',
  mixins: [addSlotClasses],
  props: {
    onSubmit: {
      type: [Function],
    },
  },
  components: {
    VButton,
    VInput,
  },
  data() {
    return {
      headerClass: 'o-form__header',
      rowClass: 'o-form__row',
      formButtonsClass: 'o-form__buttons',
    };
  },
  mounted() {
    this.addSlotClasses();
  },
  updated() {
    this.addSlotClasses();
  },
  methods: {
    submit() {
      const validationScope = this.$el.getAttribute('data-vv-scope');
      this.onSubmit(validationScope);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.o-form';

  #{$parent} {
    @include clearfix;
    //elements
    &__row {
      margin-top: $spacing-base;
      @include clearfix;
      &:first-child {
        margin-top: 0;
      }
      /deep/ b {
        display: block;
        margin-bottom: $spacing-xs;
      }
      /deep/ .a-message {
        margin-top: $spacing-small;
      }
      &--split {
        margin-top: $spacing-base;
        padding-top: $spacing-base;
        border-top: 1px solid $color-border;
      }
    }
    &__buttons {
      margin-top: $spacing-base;
      @include clearfix;
      a {
        margin-left: $spacing-base;
        &:first-child {
          margin-left: 0;
        }
      }
      &--right {
        float: right;
      }
      &--left {
        float: left;
      }
    }
  }
</style>
